import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10 flex flex-col items-center">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900">Page Not Found</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-600">The page you are looking for does not exist or has been moved.</p>
        <Link
          to="/"
          className="whitespace-nowrap mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
        >
          <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}